import React, { useState } from 'react';
import { Button, KIND as BUTTON_KIND } from 'baseui/button';
import { Modal, ModalBody, ModalFooter, ModalHeader, ROLE as MODAL_ROLE, SIZE as MODAL_SIZE } from 'baseui/modal';
import { ParagraphSmall } from 'baseui/typography';
type PropsT = {
  isOpen: boolean;
  label: string;
  onCancel: () => void;
  onConfirm: () => Promise<void>;
};
export function DeleteAllAnnotationsConfirmationModal({
  isOpen,
  label,
  onCancel,
  onConfirm
}: PropsT) {
  const [isLoading, setIsLoading] = useState(false);
  const handleConfirm = async () => {
    setIsLoading(true);
    await onConfirm();
    setIsLoading(false);
  };
  return <Modal onClose={onCancel} closeable isOpen={isOpen} animate autoFocus size={MODAL_SIZE.default} role={MODAL_ROLE.dialog}>
      <ModalHeader>Delete All Annotations</ModalHeader>
      <ModalBody>
        <ParagraphSmall>
          Are you sure you want to delete all annotations labeled <b>{label}</b>?
        </ParagraphSmall>
      </ModalBody>
      <ModalFooter>
        <Button kind={BUTTON_KIND.tertiary} onClick={onCancel} disabled={isLoading}>
          Cancel
        </Button>
        <Button kind={BUTTON_KIND.primary} onClick={handleConfirm} isLoading={isLoading}>
          Delete
        </Button>
      </ModalFooter>
    </Modal>;
}